import { Controller, useFormContext, useFormState } from 'react-hook-form';

import { Input as AntdInput } from 'antd';

import { ErrorMessage } from './ErrorMessage';

interface IProps {
  id: string;
  placeholder?: string;
  rows?: number;
  name: string;
  maxLength?: number;
}

export const TextArea = ({ id, placeholder, rows, name, maxLength }: IProps) => {
  const { control } = useFormContext();
  const { errors } = useFormState({ control });

  const message = errors[name]?.message as string | undefined;

  return (
    <div>
      <Controller
        control={control}
        name={name}
        rules={{ required: true }}
        render={({ field }) => (
          <AntdInput.TextArea
            status={message ? 'error' : ''}
            rows={rows || 4}
            maxLength={maxLength}
            id={id}
            placeholder={placeholder}
            {...field}
          />
        )}
      />
      <ErrorMessage fieldName={name} />
    </div>
  );
};
